type StorefrontHomeHeadingProps = {
  title: string
}

export function StorefrontHomeHeading({ title }: StorefrontHomeHeadingProps) {
  const normalizedTitle = title.trim()
  if (!normalizedTitle) return null

  return <h1 className="sr-only">{normalizedTitle}</h1>
}
